/* eslint-disable no-underscore-dangle */

import memoize from 'promise-memoize';
import { nullLocation } from './get-location/utils';
import { logError } from './utils';

const timeout = (ms, payload) => new Promise(resolve => setTimeout(() => resolve(payload), ms));

const isInMyJio = (window.android && window.android.__externalCall)
  || window.__externalCall
  || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callback && window.webkit.messageHandlers.callback.postMessage);
const callMyJio = data => {
  if (!isInMyJio) return;
  const payload = btoa(JSON.stringify(data));
  try {
    if (window.android && window.android.__externalCall) {
      window.android.__externalCall(payload);
    }

    if (window.__externalCall) {
      window.__externalCall(payload);
    }
    window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callback && window.webkit.messageHandlers.callback.postMessage(payload);
  } catch (e) {
    logError(e);
  }
};

const pendingPromises = {};
const valueWhenTimedOut = {};

window.sendAdParams =
  /* istanbul ignore next */
  data => {
    console.log('received location from native', data);
    const { latitude, longitude } = typeof data === 'string' ? JSON.parse(data) : data;
    pendingPromises.adparams && pendingPromises.adparams.resolve({
      latitude: latitude || null,
      longitude: longitude || null
    });
    delete pendingPromises.adparams;
  };
valueWhenTimedOut.adparams = nullLocation;

// eslint-disable-next-line no-multi-assign
window.sendJWT = window.sendJwt =
  /* istanbul ignore next */
  data => {
    // data here is a jwt token
    // console.log('received jwt from native', data);
    pendingPromises.jwt && pendingPromises.jwt.resolve(data);
    delete pendingPromises.jwt;
  };
valueWhenTimedOut.jwt = null;

const callMyJioExpectingResponse = ({ type, ...rest }) => {
  // console.log('calling native with', type);
  if (!pendingPromises[type]) {
    let resolve;
    const promise = new Promise(r => {
      resolve = r;
      callMyJio({ type, ...rest });
    });

    pendingPromises[type] = {
      resolve,
      promise: Promise.race([promise, timeout(3000, valueWhenTimedOut[type])])
    };
  }

  return pendingPromises[type].promise;
};

valueWhenTimedOut.jwt = null;

export const closeView = () => callMyJio({ type: 'close' });
export const openBrowser = (url) => callMyJio({ type: 'launchcustombrowser', value: url });
export const getJwtToken = memoize(() => callMyJioExpectingResponse({ type: 'jwt' }));
export const getLocation = memoize(() => callMyJioExpectingResponse({ type: 'adparams' }));
export const loadingCompleted = () => callMyJio({ type: 'loadingCompleted' });

const test_main = {
  callMyJio,
  closeView,
  loadingCompleted,
};
export default test_main;
